import { BBOT_SUPPORT_EMAIL, BBOT_SUPPORT_PHONE } from "Constants";

export const AVAILABLE_HOURS_ROUTE = "/available-hours";

// The legacy AngularJS console path for this page (behind the hash router).
export const LEGACY_CONSOLE_PATH = "/#!/edit/schedule";

export const DAY_LABELS: Record<string, string> = {
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
};

export const SCHEDULE_PLACEHOLDER = "11AM - 2AM";

export const ORDERS_SCHEDULE_OPTIONS = [
  { value: "inheritfromprepstation", label: "Inherit from prep station" },
  { value: "useschedule", label: "By schedule (as long as the prep station has ordering enabled)" },
];

export const UNFULFILLABLE_ITEM_OPTIONS = [
  { value: "always", label: "Always show unfulfillable items" },
  { value: "never", label: "Never show unfulfillable items" },
  { value: "menu_off", label: "Only show unfulfillable items if the whole menu is unfulfillable" },
  { value: "all_menus_off", label: "Show unfulfillable items only if all menus are unfulfillable" },
];

export const MAX_ORDER_AHEAD_HOURS = 2040;
export const MIN_TIMEBLOCK_INTERVAL = 10;

// The backend doesn't return a support contact directly; the legacy AngularJS app derived
// it client-side from the customer's referrer (ownerservices.js's supportConfigDict). Ported
// here since getOwnerProperties only returns the raw referrer, not a derived contact object.
export const TECH_SUPPORT_CONTACT_BY_REFERRER: Record<string, { phone: string; text: string; email: string }> = {
  "": { phone: "", text: BBOT_SUPPORT_PHONE, email: BBOT_SUPPORT_EMAIL },
  sevenrooms: { phone: BBOT_SUPPORT_PHONE, text: "", email: BBOT_SUPPORT_EMAIL },
  "7shifts": { phone: BBOT_SUPPORT_PHONE, text: "", email: BBOT_SUPPORT_EMAIL },
};
